// Helper functions for form submissions

import { hotelsAPI } from '../services/api';
import axios from 'axios';
import { formatHotelDataForSubmission } from './hotelHelpers';
import { formatRoomDataForSubmission } from './roomHelpers';

/**
 * Handle hotel form submission with file upload
 * @param {Object} e - The event object
 * @param {Function} validateHotelForm - Function to validate hotel form
 * @param {Object} hotelFormData - Current hotel form data
 * @param {Object} editingHotel - Current editing hotel
 * @param {Function} setFormErrors - State setter for form errors
 * @param {Function} setErrors - State setter for errors
 * @param {Function} fetchHotels - Function to fetch hotels
 * @param {Function} resetHotelForm - Function to reset hotel form
 */
export const handleHotelSubmit = async (e, validateHotelForm, hotelFormData, editingHotel, setFormErrors, setErrors, fetchHotels, resetHotelForm) => {
  e.preventDefault();
  
  const errors = validateHotelForm(hotelFormData, !!editingHotel);
  if (Object.keys(errors).length > 0) {
    setFormErrors(prev => ({ ...prev, hotel: errors }));
    return;
  }
  
  try {
    const submitData = formatHotelDataForSubmission(hotelFormData);
    
    if (editingHotel) {
      const response = await hotelsAPI.update(editingHotel.id, submitData);
      // Refresh the hotels list
      await fetchHotels();
    } else {
      const response = await hotelsAPI.create(submitData);
      // Refresh the hotels list
      await fetchHotels();
    }
    
    resetHotelForm();
  } catch (error) {
    console.error('Error saving hotel:', error);
    setErrors(prev => ({ ...prev, hotelForm: error.message || 'Failed to save hotel' }));
  }
};

export default {
  handleHotelSubmit
};